function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHonorAward = function SvgHonorAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70 35c0 19.3-15.7 35-35 35S0 54.3 0 35 15.7 0 35 0s35 15.7 35 35",
    className: "honor-award_svg__st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffd040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 24.4h-6.7v-2.6c0-.9-.7-1.5-1.5-1.5H26.2c-.9 0-1.5.7-1.5 1.5v2.6H18c-.9 0-1.5.7-1.5 1.5v3.6c0 2.3 1.4 4.6 4 6.4 2 1.5 4.5 2.4 7 2.7 2 3.3 4.4 4.7 4.4 4.7v4.6h-3.1c-2.3 0-4.1 1.3-4.1 3.6v.8c0 .4.3.8.8.8h18.9c.4 0 .8-.3.8-.8v-.8c0-2.3-1.8-3.6-4.1-3.6H38v-4.6s2.3-1.4 4.4-4.7c2.6-.3 5-1.2 7-2.7 2.5-1.8 4-4.2 4-6.4v-3.6c0-.8-.7-1.5-1.6-1.5m-28.9 8.2c-1.6-1.1-2.3-2.4-2.3-3.1v-1h4.1c.1 2.1.4 3.9.8 5.5-.9-.3-1.8-.8-2.6-1.4m26.4-3.1c0 1-1.1 2.3-2.3 3.1-.8.6-1.7 1-2.7 1.4.4-1.6.8-3.4.8-5.5h4.1v1z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgHonorAward;